<template>
    <v-container>
        <v-layout row wrap>
            <v-flex xs12 s12 md12>
                <div>
                    <v-dialog
                            v-model="dialog_create2"
                            persistent
                            max-width="600px"
                            :disabled="activo"
                    >
                        <v-btn flat block slot="activator" :loading="loading" :disabled="activo"><v-icon left>mdi-folder-plus</v-icon>Add folder</v-btn>
                        <v-card>
                            <v-card-title>
                                <span class="headline">Add folder:</span>
                            </v-card-title>
                            <v-card-text>
                                <v-container grid-list-md>
                                    <v-layout wrap>
                                        <v-flex xs12 sm12 md12>
                                            <v-text-field label="Folder name" v-model="folder_name" required></v-text-field>
                                        </v-flex>
                                    </v-layout>
                                </v-container>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="blue darken-1" flat @click="dialog_create2 = false">Close</v-btn>
                                <v-btn color="blue darken-1" flat @click="createFolder2()">Save</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                    <v-btn flat @click="deleteFile2()" :loading="loading" :disabled="activo"><v-icon left>mdi-folder-plus</v-icon>Delete folder</v-btn>
                    <v-dialog
                            v-model="dialog_rename2"
                            persistent
                            max-width="600px"
                            :disabled="activo"
                    >
                        <v-btn flat block slot="activator" :loading="loading" :disabled="activo"><v-icon left>mdi-folder-edit</v-icon> Rename folder</v-btn>
                        <v-card>
                            <v-card-title>
                                <span class="headline">Rename folder:</span>
                            </v-card-title>
                            <v-card-text>
                                <v-container grid-list-md>
                                    <v-layout wrap>
                                        <v-flex xs12 sm12 md12>
                                            <v-text-field label="Folder name" v-model="folder_name" required></v-text-field>
                                        </v-flex>
                                    </v-layout>
                                </v-container>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="blue darken-1" flat @click="dialog_rename2 = false">Close</v-btn>
                                <v-btn color="blue darken-1" flat @click="renameFolder2()">Save</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                    <v-dialog
                            v-model="dialog_upload2"
                            persistent
                            max-width="600px"
                            :disabled="activo"
                    >
                        <v-btn flat block slot="activator" @click="dropzoneOptions.url = API_BASE + 'samples/' + order_id + '/folder/' + selected + '/document'" :loading="loading" :disabled="activo"><v-icon left>mdi-file-plus</v-icon> Add file</v-btn>
                        <v-card>
                            <v-card-title>
                                <span class="headline">Upload files:</span>
                            </v-card-title>
                            <v-card-text>
                                <v-container grid-list-md>
                                    <v-layout wrap>
                                        <v-flex xs12 s12 md12 class="mt-4">
                                            <vue-dropzone v-if="dialog_upload2" ref="myVueDropzone" id="dropzone4" :options="dropzoneOptions" v-on:vdropzone-success="getDocuments()"></vue-dropzone>
                                        </v-flex>
                                    </v-layout>
                                </v-container>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="blue darken-1" flat @click="dialog_upload2 = false">Close</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </div>
                <div>
                    <v-divider class="mt-2 mb-2"></v-divider>
                    <h3>Selecciona una carpeta o archivo.</h3>
                    <v-divider class="mt-2 mb-2">
                    </v-divider>
                </div>
            </v-flex>
            <v-flex xs12 s12 md12>
                <v-treeview
                        v-if="documents.length > 0"
                        :items="documents"
                        open-all
                        v-model="tree"
                        activatable
                        @update:active="select($event)"
                        return-object
                        :active="activos"
                >
                    <template slot="prepend" slot-scope="{ item, open, leaf }">
                        <v-icon v-if="!item.file" @contextmenu="show($event, item.id)">
                            {{ open ? 'mdi-folder-open' : 'mdi-folder' }}
                        </v-icon>
                        <v-icon v-else @contextmenu="showFile($event, item.id, item.document)">
                            {{ files[item.file] }}
                        </v-icon>
                    </template>
                    <template slot="label" slot-scope="{ item, open, leaf }">
                        {{ item.name }}
                        <v-btn v-if="item.file" flat :href="BASE + 'sample-order/' + order_id + '/pdf/' + item.document.id + '?token=' + item.document.token + '&download_token=' + download_token" target="_blank"><v-icon>mdi-cloud-download</v-icon></v-btn>
                        <v-btn
                                v-if="item.file"
                                flat icon
                                @click.stop="dialog = item.id"
                        >
                            <v-icon>redo</v-icon>
                        </v-btn>
                        <v-btn v-if="item.file" icon @click="deleteFile3(item.id)"><v-icon>mdi-delete-circle</v-icon></v-btn>
                    </template>
                </v-treeview>
                <MoveDocumentComponent
                        v-if="dialog"
                        :documents="documents"
                        :dialog="dialog"
                        v-on:close="dialog = false"
                        model="sample"
                        v-on:editado="getDocuments(), dialog = false"
                ></MoveDocumentComponent>
                <v-menu
                        v-model="showMenuFolder"
                        :position-x="x"
                        :position-y="y"
                        absolute
                        offset-y
                >
                    <v-list>
                        <v-list-tile
                        >
                            <v-dialog v-model="dialog_create" persistent max-width="600px">
                                <v-btn flat block slot="activator"><v-icon left>mdi-folder-plus</v-icon>Add folder</v-btn>
                                <v-card>
                                    <v-card-title>
                                        <span class="headline">Add folder:</span>
                                    </v-card-title>
                                    <v-card-text>
                                        <v-container grid-list-md>
                                            <v-layout wrap>
                                                <v-flex xs12 sm12 md12>
                                                    <v-text-field label="Folder name" v-model="folder_name" required></v-text-field>
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card-text>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn color="blue darken-1" flat @click="dialog_create = false">Close</v-btn>
                                        <v-btn color="blue darken-1" flat @click="createFolder()">Save</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-list-tile>

                        <v-list-tile
                        >
                            <v-btn flat block @click="deleteFile()"><v-icon left>mdi-folder-plus</v-icon>Delete folder</v-btn>
                        </v-list-tile>

                        <v-list-tile
                        >
                            <v-dialog v-model="dialog_rename" persistent max-width="600px">

                                <v-btn flat block slot="activator"><v-icon left>mdi-folder-edit</v-icon> Rename folder</v-btn>
                                <v-card>
                                    <v-card-title>
                                        <span class="headline">Rename folder:</span>
                                    </v-card-title>
                                    <v-card-text>
                                        <v-container grid-list-md>
                                            <v-layout wrap>
                                                <v-flex xs12 sm12 md12>
                                                    <v-text-field label="Folder name" v-model="folder_name" required></v-text-field>
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card-text>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn color="blue darken-1" flat @click="dialog_rename = false">Close</v-btn>
                                        <v-btn color="blue darken-1" flat @click="renameFolder()">Save</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-list-tile>

                        <v-list-tile
                        >
                            <v-dialog v-model="dialog_upload" persistent max-width="600px">

                                <v-btn flat block slot="activator"><v-icon left>mdi-file-plus</v-icon> Add file</v-btn>
                                <v-card>
                                    <v-card-title>
                                        <span class="headline">Upload files:</span>
                                    </v-card-title>
                                    <v-card-text>
                                        <v-container grid-list-md>
                                            <v-layout wrap>
                                                <v-flex xs12 s12 md12 class="mt-4">
                                                    <vue-dropzone v-if="dialog_upload" ref="myVueDropzone" id="dropzone" :options="dropzoneOptions" v-on:vdropzone-success="getDocuments()"></vue-dropzone>
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card-text>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn color="blue darken-1" flat @click="dialog_upload = false">Close</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-list-tile>
                    </v-list>
                </v-menu>
                <v-menu
                        v-model="showMenuFile"
                        :position-x="x"
                        :position-y="y"
                        absolute
                        offset-y
                >
                    <v-list>
                        <v-list-tile
                        >
                            <v-btn flat block @click="deleteFile(folder_id)"><v-icon left>mdi-delete-circle</v-icon>Delete file</v-btn>

                        </v-list-tile>
                        <v-list-tile
                        >
                            <v-btn v-if="showMenuFile" flat block :href="BASE + 'sample-order/' + order_id + '/pdf/' + document.id + '?token=' + document.token + '&download_token=' + download_token" target="_blank"><v-icon left>mdi-cloud-download</v-icon>Download</v-btn>

                        </v-list-tile>
                    </v-list>
                </v-menu>
            </v-flex>
        </v-layout>
        <v-snackbar
                v-model="snackbar"
                multi-line=""
                top
                vertical=""
        >
            {{ text }}
            <v-btn
                    color="pink"
                    flat
                    @click="snackbar = false"
            >
                Close
            </v-btn>
        </v-snackbar>
        <br>
        <CommentComponent :sample="sample"></CommentComponent>
    </v-container>
</template>

<script>
    import MoveDocumentComponent from '../../../shared/components/MoveDocumentComponent';
    import vue2Dropzone from 'vue2-dropzone'
    import CommentComponent from './components/CommentComponent';
    import 'vue2-dropzone/dist/vue2Dropzone.min.css'

    import { API_BASE } from  '../../../../../src/config.js';
    import { BASE } from "../../../../../src/config";

    export default {
        props: ['order_id', 'sample'],
        data: function () {
            return {
                dropzoneOptions: {
                    url: '',
                    thumbnailWidth: 150,
                    maxFilesize: 500,
                    headers: { 'Authorization' : localStorage.getItem('token'),
                        'Autrollization' : localStorage.getItem('token'),
                        'Authorization-temp' : localStorage.getItem('token')
                    },
                    addRemoveLinks: true,
                },
                documents: [],
                API_BASE: API_BASE,
                BASE: BASE,
                open: ['public'],
                files: {
                    html: 'mdi-language-html5',
                    js: 'mdi-nodejs',
                    json: 'mdi-json',
                    md: 'mdi-markdown',
                    pdf: 'mdi-file-pdf',
                    png: 'mdi-file-image',
                    txt: 'mdi-file-document-outline',
                    xls: 'mdi-file-excel'
                },
                tree: [],
                showMenuFolder: false,
                showMenuFile: false,
                x: 0,
                y: 0,
                folder_id: null,
                document: null,
                dialog_create: false,
                dialog_rename: false,
                dialog_upload: false,
                dialog_create2: false,
                dialog_rename2: false,
                dialog_upload2: false,
                folder_name: '',
                snackbar: false,
                text: 'Hello, I\'m a snackbar',
                selected: null,
                tipo: null,
                token: null,
                document_id: null,
                loading: false,
                download_token: null,
                activos: [],
                dialog: false
            }
        },
        components: {
            vueDropzone: vue2Dropzone,
            CommentComponent,
            MoveDocumentComponent
        },
        created () {
            this.checkUser();
            this.getDocuments();
        },
        computed: {
            activo: function () {
                if (this.tipo == 'folder' && this.selected) {
                    return false;
                } else {
                    return true;
                }
            }
        },
        methods: {
            checkUser() {
                this.$store.dispatch('checkAccessToken').then((res) => {
                    this.download_token = this.$store.getters.getUser.download_token;
                }).catch((error) => {

                });
            },
            setTipo (id) {
                this.loading = true;
                this.$store.dispatch('getTipoDocument', {
                    sample_order_id: this.order_id,
                    document_id: id
                }).then((res) => {
                    this.tipo = res.data.tipo;
                    this.token = res.data.token;
                    this.document_id = res.data.document_id;
                    this.loading = false;
                }).catch((error) => {

                });
            },
            select (payload) {
                if (payload[0] != undefined) {
                    this.selected = payload[0].id;
                    this.setTipo(payload[0].id)
                } else {
                    this.selected = null;
                }
            },
            getDocuments () {
                this.$store.dispatch('getDirectoriesSamples', {
                    order_id: this.order_id
                }).then((res) => {
                    this.documents = res.data.data;
                    this.select([res.data.data[0]]);
                    this.activos.push(res.data.data[0]);
                    this.dialog_rename = false;
                    this.dialog_create = false;
                    this.dialog_upload = false;
                    this.dialog_rename2 = false;
                    this.dialog_create2 = false;
                    this.dialog_upload2 = false;
                    this.showMenuFolder = false;
                    this.showMenuFile = false;
                }).catch((error) => {

                });
            },
            show (e, folder_id) {
                e.preventDefault()
                this.showMenuFolder = false
                this.x = e.clientX
                this.y = e.clientY
                this.$nextTick(() => {
                    this.showMenuFolder = true;
                    this.folder_id = folder_id;
                    this.folder_name = '';
                    this.dropzoneOptions.url = API_BASE + 'samples/' + this.order_id + '/folder/' + this.folder_id + '/document';
                })
            },
            showFile (e, folder_id, document) {
                e.preventDefault()
                this.showMenuFile = false
                this.x = e.clientX
                this.y = e.clientY
                this.$nextTick(() => {
                    this.showMenuFile = true;
                    this.folder_id = folder_id;
                    this.folder_name = '';
                    this.document = document;
                })
            },
            createFolder () {
                this.$store.dispatch('createSampleFolder', {
                    order_id: this.order_id,
                    folder_id: this.folder_id,
                    folder_name: this.folder_name
                }).then((res) => {
                    this.getDocuments();
                }).catch((error) => {

                });
            },
            createFolder2 () {
                console.log('creando');
                this.$store.dispatch('createSampleFolder', {
                    order_id: this.order_id,
                    folder_id: this.selected,
                    folder_name: this.folder_name
                }).then((res) => {
                    this.selected = null;
                    this.folder_name = '';
                    this.getDocuments();
                }).catch((error) => {

                });
            },
            renameFolder () {
                this.$store.dispatch('renameSampleFolder', {
                    order_id: this.order_id,
                    folder_id: this.folder_id,
                    folder_name: this.folder_name
                }).then((res) => {
                    this.getDocuments();
                }).catch((error) => {

                });
            },
            renameFolder2 () {
                this.$store.dispatch('renameSampleFolder', {
                    order_id: this.order_id,
                    folder_id: this.selected,
                    folder_name: this.folder_name
                }).then((res) => {
                    this.selected = null;
                    this.folder_name = '';
                    this.getDocuments();
                }).catch((error) => {

                });
            },
            deleteFile (folder_id) {
                this.$store.dispatch('deleteSampleFolder', {
                    order_id: this.order_id,
                    folder_id: this.folder_id
                }).then((res) => {
                    this.getDocuments();
                }).catch((error) => {
                    this.text = error.data.mensaje;
                    this.snackbar = true;
                });
            },
            deleteFile2 () {
                this.$store.dispatch('deleteSampleFolder', {
                    order_id: this.order_id,
                    folder_id: this.selected
                }).then((res) => {
                    this.selected = null;
                    this.getDocuments();
                }).catch((error) => {
                    this.text = error.data.mensaje;
                    this.snackbar = true;
                });
            },
            deleteFile3 (folder_id) {
                this.$store.dispatch('deleteSampleFolder', {
                    order_id: this.order_id,
                    folder_id: folder_id
                }).then((res) => {
                    this.getDocuments();
                }).catch((error) => {
                    this.text = error.data.mensaje;
                    this.snackbar = true;
                });
            },
        },
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/admin/samples/views/SampleRequestComponent.vue